import BaseLayout from './base.layout.vue';
import ToolLayout from './tool.layout.vue';

export const layouts = {
  base: BaseLayout,
  toolLayout: ToolLayout,
};
